<template>
	<div class="main">
		<a href="https://dsglobaloffshoreengineering.godaddysites.com/" target="_blank"><i class="el-icon-thumb"></i>Singapore Branch Official website</a>
	</div>
</template>

<script>
export default {
	name: "Singapore"
}
</script>

<style scoped>
.main{ margin-top: 30px; animation: fadeInUp; animation-duration: 1.5s; }
a{ color: #cecece; transition: all 0.28s linear; }
.main{ font-family: 'SiYuan-ExtraLight', sans-serif; }
a:hover{ color: #325b80; letter-spacing: 2px; }
@media (max-width: 500px){
}
@media (min-width: 500px) and (max-width: 726px){
}
@media (min-width: 726px) and (max-width: 999px){
}
@media (min-width: 999px) and (max-width: 1251px){
}
@media (min-width: 1252px) and (max-width: 1845px){
}
@media (min-width: 1846px) and (max-width: 2200px){
}
@media (min-width: 2201px){
}
</style>